<script>
import Layout         from "@/router/layouts/main";
import Reviews        from "@/router/views/reputation/daily-operations/reviews/index";
import ExtensionUtils from "@/js/extension";
import Utils          from "@/js/utils";
import axios          from "axios";

export default {
  data() {
    return {
      companiesHash: {},
      company: null,
      source:  null,
      url:     null,
      params:  {},
    };
  },
  components: { Layout, Reviews },
  created() {
    window.addEventListener("message", async ev => {
      if (ev.data?.type == "OLY_DASHBOARD_UPDATE_PARAMS") {
        const p = JSON.parse(ev.data.params || "{}");
        this.source = p.srcs;
        this.url    = p.url;
        this.params = { ...p };
      }
    });
    this.notifyExtension({ type: "OLY_CONTENT_DASHBOARD_LOADED" });
  },
  methods: {
    ...Utils.extension,
    async init() {
      if (!(this.source && this.contract?.id && this.url) || this.params.cids) return;
      await this.loadCompanies();
      this.company = ExtensionUtils[this.source]?.getCompanyId({ url: this.url, companies: this.companiesHash[this.contract.id] });
      if (this.company?.id) {
        await this.$router.replace({ query: { ...this.params, cids: this.company.id } });
      }
    },
    async loadCompanies() {
      if (this.companiesHash[this.contract?.id]?.length) return;
      this.companiesHash[this.contract.id] = (await axios.get("v3/companies", { params: { subscription_ids: this.contract.id } }))?.data?.data || [];
    },
    async updateParamsAndSubmit() {
      await this.$router.replace({ query: this.params });
      if (this.$refs.reviewsRef) this.$refs.reviewsRef.triggerFilterSubmit();
    }
  },
  computed: {
    contract() {
      return this.$store.getters["contract/currentContract"];
    },
    routeParams() {
      return this.$route.query;
    },
    showReviewsPage() {
      if (!this.params.is_ota || this.params.is_ota == "false") return true;
      return !!this.company?.id || this.params.cids;
    }
  },
  watch: {
    contract: {
      handler: function () {
        if (this.contract?.id) this.init();
      },
      immediate: true,
      deep: true
    },
    params: {
      async handler() {
        if (Object.keys(this.params).length) {
          await this.init();
          this.updateParamsAndSubmit();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<template>
  <Layout :hide_sidebar="true" :no_footer="true">
    <Reviews ref="reviewsRef" v-if="showReviewsPage" :insideExtension="true" :extensionParams="params" />
    <div v-else class="d-flex card flex-column align-items-center justify-content-center h-100 w-100 py-4 mt-3">
      <h5 class="m-0 text-center">{{ $t("general.no_company_match") }}</h5>
    </div>
  </Layout>
</template>
